/** @format */
import radioTpl from './radio.tpl.html';

export const radioModule = 'sis-components.radio';

(function () {
    angular.module(radioModule, []).directive('radio', radio);

    function radio() {
        return {
            element: 'E',
            require: ['ngModel'],
            scope: {
                ngModel: '=',
                cb: '&ngChange',
                ngValue: '=',
                disabled: '=',
                inline: '@',
                label: '@',
                name: '@',
            },
            template: radioTpl,
        };
    }
})();
